export default "__VITE_ASSET__xUvNvXfi__"